/**
 * Viewport width, live. One resize listener per hook use — cheap, and it lets
 * layout react to the browser actually changing size (founder 2026-07-05:
 * "the size of the table isn't really moving with my browser").
 */
import { useEffect, useState } from "react";

export function useViewportWidth(): number {
  const [w, setW] = useState<number>(() => (typeof window !== "undefined" ? window.innerWidth : 1280));
  useEffect(() => {
    // rAF-throttled: dragging a window edge fires resize per pixel; one state
    // update per frame is plenty and keeps the layout re-renders cheap.
    let frame = 0;
    const on = (): void => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; setW(window.innerWidth); });
    };
    window.addEventListener("resize", on);
    return () => { window.removeEventListener("resize", on); if (frame) cancelAnimationFrame(frame); };
  }, []);
  return w;
}

/** Breakpoints, one place. Below `nav` the left sidebar auto-collapses; below
 *  `rail` the right filter rail does; below `grid` cards stack single-column. */
export const BREAK = { nav: 900, rail: 1100, grid: 840 } as const;
